import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'quit_goals'

const OPTIONS = [
  {
    value: 'quit-completely',
    translationKey: 'pages.onboarding.quitGoals.options.quit-completely',
  },
  {
    value: 'reduce-anxiety',
    translationKey: 'pages.onboarding.quitGoals.options.reduce-anxiety',
  },
  {
    value: 'avoid-relapse',
    translationKey: 'pages.onboarding.quitGoals.options.avoid-relapse',
  },
  {
    value: 'learn-about-habits',
    translationKey: 'pages.onboarding.quitGoals.options.learn-about-habits',
  },
  {
    value: 'track-progress',
    translationKey: 'pages.onboarding.quitGoals.options.track-progress',
  },
]

const ANSWER_TEXTS = {
  'quit-completely': 'Quit completely',
  'reduce-anxiety': 'Reduce anxiety',
  'avoid-relapse': 'Avoid relapse',
  'learn-about-habits': 'Learn about my habits',
  'track-progress': 'Track my progress',
}

export default function QuitGoalsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const answerValue = formData.get('answer') as string

    if (!answerValue) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What would you like to achieve with UnVape?',
      answer_key: answerValue,
      answer: ANSWER_TEXTS[answerValue as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.quitGoals.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
